import React, { forwardRef } from 'react';
import * as cls from './typography.module.css';

/**
 * Typography component that renders semantic text elements with flexible styling.
 *
 * @param {Object} props - Component props
 * @param {string} [props.tag='h1'] - The HTML tag to render (e.g., 'h1', 'p', 'span').
 * @param {string} props.as - The style variant to apply (e.g., 'h1', 'h2', 'p').
 * @param {React.ReactNode} props.children - The content to display inside the component.
 *
 * @returns {JSX.Element} A semantic text element with the desired styling.
 *
 * @example
 * // Renders an <h1> element styled like an h2
 * <Typography tag="h1" as="h2">Hello</Typography>
 */
export const Typography = forwardRef(
  ({ as, children, className = '', style = {}, tag = 'p' }, ref) => {
    const Tag = tag;
    const styleAs = as ?? tag;
    return (
      <Tag className={`${cls[styleAs]} ${className}`} style={style} ref={ref}>
        {children}
      </Tag>
    );
  },
);

export const TypographyHighlight = ({ breakLine, children }) => {
  return (
    <em
      className={`${cls.highlight}${breakLine ? ' ' + cls['highlight--breakLine'] : ''}`}
    >
      {children}
    </em>
  );
};
